import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "main-content bg_gray d-flex flex-column transition overflow-hidden" }
const _hoisted_2 = { class: "chart-wrapper style-one d-flex" }
const _hoisted_3 = { class: "card border-0 rounded-1 mb-20" }
const _hoisted_4 = { class: "card-body p-xl-40" }
const _hoisted_5 = { class: "chart-body" }
const _hoisted_6 = { class: "card border-0 rounded-1 mb-20" }
const _hoisted_7 = { class: "card-body p-xl-40" }
const _hoisted_8 = { class: "chart-wrapper style-two d-flex" }
const _hoisted_9 = { class: "card border-0 rounded-1 mb-20" }
const _hoisted_10 = { class: "card border-0 rounded-1 mb-20" }
const _hoisted_11 = { class: "chart-wrapper style-three d-flex flex-wrap" }
const _hoisted_12 = { class: "card border-0 rounded-1 mb-20" }
const _hoisted_13 = { class: "card border-0 rounded-1 mb-20" }
const _hoisted_14 = { class: "card border-0 shadow-none rounded-1 mb-20" }
const _hoisted_15 = { class: "card border-0 shadow-none rounded-1 mb-40" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MainHeader = _resolveComponent("MainHeader")!
  const _component_MainSidebar = _resolveComponent("MainSidebar")!
  const _component_StatusContent = _resolveComponent("StatusContent")!
  const _component_TopSellingProductsChart = _resolveComponent("TopSellingProductsChart")!
  const _component_ThisWeeksSalesPurchasesChart = _resolveComponent("ThisWeeksSalesPurchasesChart")!
  const _component_StockAlert = _resolveComponent("StockAlert")!
  const _component_TopCustomerChart = _resolveComponent("TopCustomerChart")!
  const _component_SalesTargetChart = _resolveComponent("SalesTargetChart")!
  const _component_PaymentSentReceivedChart = _resolveComponent("PaymentSentReceivedChart")!
  const _component_RecentInvoices = _resolveComponent("RecentInvoices")!
  const _component_RecentSales = _resolveComponent("RecentSales")!
  const _component_MainFooter = _resolveComponent("MainFooter")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_MainHeader),
    _createVNode(_component_MainSidebar),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_StatusContent),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _cache[0] || (_cache[0] = _createElementVNode("h6", { class: "card-title fw-semiBold fs-18 mb-30" }, " Top Selling Products (2023) ", -1)),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_TopSellingProductsChart)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _cache[1] || (_cache[1] = _createElementVNode("h6", { class: "card-title fw-semiBold fs-18 mb-30" }, " This Weeks Sales & Purchases ", -1)),
            _createVNode(_component_ThisWeeksSalesPurchasesChart)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_StockAlert)
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_component_TopCustomerChart)
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _createVNode(_component_SalesTargetChart)
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createVNode(_component_PaymentSentReceivedChart)
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createVNode(_component_RecentInvoices)
        ])
      ]),
      _createElementVNode("div", _hoisted_15, [
        _createVNode(_component_RecentSales)
      ]),
      _cache[2] || (_cache[2] = _createElementVNode("div", { class: "flex-grow-1" }, null, -1)),
      _createVNode(_component_MainFooter)
    ])
  ], 64))
}